import { AssignmentDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { EvolveProductType } from '../../apis/sherpath-app-facade-service/sherpath-app-facade-service.dtos';
import { RoutePath } from '../../components/app/app.constants';
import { AssignmentEditorSearchParam } from '../../hocs/with-base-assignment-editor/with-base-assignment-editor.constants';
import { GetAssignmentInfoProps, RecContentItemTitleHandlerProps, RecContentItemTitleHandlerPropsClone } from '../../models/assignment-types-shared.models';
import { getBookTaxonomy,
  getChapterIdsFromPageRanges,
  getChapterPageRangesFromPageRanges,
  getDefaultChapterPageRanges,
  getEbookAssignmentInfo,
  getFirstPage } from '../../pages/ebook-assignment-editor/ebook-assignment.utilities';
import { ReduxPage } from '../../redux/courseware/courseware.models';
import { addSearchParams } from '../../utilities/app.utilities';
import { getEbookReadingTitle, getIsbnFromEbookSyllabusItem, getPageRangesFromEbookSyllabusItem } from '../../utilities/assignment-types-shared.utilities';
import { AssignmentTypeStrategy, CoursePlanClickSettings, CoursePlanTitleClickProps } from '../model';

export const ebookReading: AssignmentTypeStrategy = {
  coursePlanTitleClick: (props: CoursePlanTitleClickProps) => {
    const { syllabusItem, assignment, defArgs } = props;
    const { openVitalSource } = defArgs.props;
    if (assignment) {
      return Promise.resolve(
        openVitalSource(assignment.isbn, getFirstPage(assignment.assignmentGoals.map(x => x.text)))
      );
    }

    return Promise.resolve(
      openVitalSource(
        getIsbnFromEbookSyllabusItem(syllabusItem),
        getFirstPage([getPageRangesFromEbookSyllabusItem(syllabusItem)])
      )
    );
  },
  coursePlanClickSettings: (props: CoursePlanClickSettings) => {
    const { syllabusItem, assignment, sharedSearchParams, defArgs } = props;
    const { redirect } = defArgs.props;
    redirect(addSearchParams(RoutePath.EBOOK_ASSIGNMENT_EDITOR, {
      ...sharedSearchParams,
      [AssignmentEditorSearchParam.PAGE_RANGES]: assignment ? null : getPageRangesFromEbookSyllabusItem(syllabusItem)
    }));
  },
  assignmentInfoHandler: (props: GetAssignmentInfoProps): Promise<AssignmentDto> => {
    const {
      newAssignment,
      fetchPrimaryTaxonomies,
      syllabusItem
    } = props;
    const pageRanges = getPageRangesFromEbookSyllabusItem(syllabusItem);
    return fetchPrimaryTaxonomies([{
      isbn: newAssignment.isbn,
      isbnType: EvolveProductType.EBOOK,
      taxonomy: null
    }], true, ReduxPage.EBOOK_EDITOR_PAGE).then((ebookPrimaryTaxonomies) => {
      const taxonomy = getBookTaxonomy(newAssignment.isbn, ebookPrimaryTaxonomies);
      const checkedChapterIds = getChapterIdsFromPageRanges(pageRanges, taxonomy);
      const chapterPageRanges = {
        ...getDefaultChapterPageRanges(taxonomy),
        ...getChapterPageRangesFromPageRanges(pageRanges, taxonomy)
      };
      const assignmentInfo = getEbookAssignmentInfo(taxonomy, checkedChapterIds, newAssignment, chapterPageRanges);
      return {
        ...newAssignment,
        ...assignmentInfo,
      };
    });
  },
  recContentItemTitleHandler: (props: RecContentItemTitleHandlerProps) => {
    const { contentItem, primaryTaxonomies } = props;
    return getEbookReadingTitle(contentItem, primaryTaxonomies);
  },
  recContentItemTitleHandlerClone: (props: RecContentItemTitleHandlerPropsClone) => {
    const { contentItem, primaryTaxonomies } = props;
    return getEbookReadingTitle(contentItem, primaryTaxonomies);
  },
  isScorable: false,
};
